import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  section {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 18px;

    & h3 {
      margin-bottom: 30px;
      font-size: 20px;
    }

    .birthdate-row {
      display: flex;
      flex-direction: row;
      gap: 15px;

      > div {
        flex: 1;
      }
    }

    .select {
      margin-bottom: 35px;
      font-size: 15px;
    }

    .prm-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      margin-bottom: 35px;
      cursor: pointer;

      img {
        width: 25px;
        height: 25px;
      }

      span {
        font-size: 15px;
      }
    }

    .documents-section {
      margin-top: 10px;

      .document-tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;
      }

      .document-tag {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        border-radius: 20px;
        background-color: ${ ({ theme }) => theme.colors.greyLight };
        font-size: 14px;

        img {
          width: 12px;
          height: 12px;
          cursor: pointer;
        }

        &.add {
          cursor: pointer;

          img {
            width: 14px;
            height: 14px;
          }
        }
      }

      .document-upload-form {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-bottom: 20px;

        p {
          font-size: 14px;
          margin: 0;
          color: ${ ({ theme }) => theme.colors.greyDark };
        }

        input[type="file"] {
          font-size: 14px;
        }

        .uploadButton {
          width: max-content;
          padding: 15px 20px;
        }
      }
    }
  }

  .saveButton {
    width: max-content;
    padding: 20px;
    float: right;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
